import React from 'react';
import type { GetProps } from '@types';
import addComponent from '@utils/addComponent';
import ConfirmModal from './ConfirmModal';

type Params = Omit<
  GetProps<typeof ConfirmModal>,
  'onRequestClose' | 'onConfirm' | 'isOpen'
>;

function showConfirmModal(props: Params): Promise<{ confirmed: boolean }> {
  return new Promise((resolve) => {
    addComponent((remove) => (
      <ConfirmModal
        isOpen
        {...props}
        onConfirm={() => {
          resolve({ confirmed: true });
          remove();
        }}
        onRequestClose={() => {
          resolve({ confirmed: false });
          remove();
        }}
      />
    ));
  });
}

export default showConfirmModal;
